import { render, staticRenderFns } from "./GlTable.vue?vue&type=template&id=3783acda&scoped=true&"
import script from "./GlTable.vue?vue&type=script&lang=js&"
export * from "./GlTable.vue?vue&type=script&lang=js&"
import style0 from "./GlTable.vue?vue&type=style&index=0&id=3783acda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3783acda",
  null
  
)

export default component.exports